import { INotification } from '../utils/entities/interface';
import { Pagination } from './booking';
import { get, post } from './https';

interface NotificationistResponse {
  status: boolean;
  data: INotification[];
  count: number;
  pagination: Pagination;
}

const GETNotifications = async ({
  page = 1,
  limit = 10,
  searchQuery = '',
  sortField = 'name',
  sortOrder = 'ASC',
}: {
  page?: number;
  limit?: number;
  searchQuery?: string;
  sortField?: string;
  sortOrder?: 'ASC' | 'DESC';
}): Promise<NotificationistResponse> => {
  // Initialize the base URL
  let url = `/api/v1/admin/promotion-list?limit=${limit}&page=${page}`;

  // Conditionally add search parameter if provided
  if (searchQuery) {
    url += `&search=${searchQuery}`;
  }

  // Conditionally add sortField and sortOrder if they are provided
  if (sortField && sortField !== 'name') {
    // assuming 'name' is the default field, you can change it if needed
    url += `&sortField=${sortField}`;
  }

  if (sortOrder && sortOrder !== 'ASC') {
    // assuming 'ASC' is the default sort order
    url += `&sortOrder=${sortOrder}`;
  }

  // Fetch the response
  const response = await get(url); // Use the previously defined `get` function

  if (response.status == 200) {
    return response.data; // If status is true, return the user data
  } else {
    throw new Error('Failed to fetch users');
  }
};

const PushPromotion = async ({
  title,
  body,
}: {
  title: string;
  body: string;
}): Promise<number> => {
  const response = await post('/api/v1/admin/promotion-notification', {
    title,
    body,
  });
  if (response.status == 200) {
    return 200; // Return success message (User activated/deactivated)
  } else {
    throw new Error(response.statusText || 'Failed to create user');
  }
};

export { GETNotifications, PushPromotion };
